<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
        <v-card>
            <v-card-title>Datos de pago</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-form ref="form">
                                <v-text-field v-model="billing_information.account" :rules="[rules.required]" filled label="N° de Tarjeta o CLABE" :color="color"></v-text-field>
                                <v-text-field v-model="billing_information.names" :rules="[rules.required]" filled label="Nombre(s)" :color="color"></v-text-field>
                                <v-text-field v-model="billing_information.paternal_surname" :rules="[rules.required]" filled label="Apellido paterno" :color="color"></v-text-field>
                                <v-text-field v-model="billing_information.maternal_surname" :rules="[rules.required]" filled label="Apellido Materno" :color="color"></v-text-field>
                                <v-text-field v-model="billing_information.bank" :rules="[rules.required]" filled label="Banco" :color="color"></v-text-field>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="$parent.billing_information_dialog = false">Cancelar</v-btn>
                <v-btn color="#008dd4" @click="submit" dark>Aceptar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:['dialog','information'],
    data:() => ({
        color:"#000000",
        rules:{
            required: v => !!v || 'El campo es requerido',
        },
        billing_information:{
            account:"",
            names:"",
            paternal_surname:"",
            maternal_surname:"",
            bank:"",
        }
    }),

    methods:{
        submit:function(){
            if(this.$refs.form.validate()){
                axios.post('/payments/billing_information/store', this.billing_information).then(response => {
                    location.reload();
                }).catch(err => {
                    
                })
            }
        }
    }
}
</script>